import { createSDKAction, onFulfill, onPending, onReject } from '../util';
import ActionTypes from '../action-types';

export function getAgentToken() {
  return createSDKAction(ActionTypes.GET_AGENT_TOKEN, {
    callback: (sdk, dispatch) => {
      dispatch({ type: onPending(ActionTypes.GET_AGENT_TOKEN) });

      return sdk
        .api('/token', {
          requiresAuthentication: true,
          method: 'post'
        })
        .then(response => {
          dispatch({ type: onFulfill(ActionTypes.GET_AGENT_TOKEN), payload: response.body });

          return Promise.resolve(response.body);
        })
        .catch(err => {
          dispatch({ type: onReject(ActionTypes.GET_AGENT_TOKEN), payload: err });

          return Promise.reject(err);
        });
    }
  });
}

export function getAgentCapabilityToken() {
  return createSDKAction(ActionTypes.GET_AGENT_CAPABILITY_TOKEN, {
    callback: (sdk, dispatch) => {
      dispatch({ type: onPending(ActionTypes.GET_AGENT_CAPABILITY_TOKEN) });

      return sdk
        .api('/token/agent', {
          requiresAuthentication: true,
          method: 'post'
        })
        .then(response => {
          dispatch({
            type: onFulfill(ActionTypes.GET_AGENT_CAPABILITY_TOKEN),
            payload: response.body
          });

          return Promise.resolve(response.body);
        })
        .catch(err => {
          dispatch({ type: onReject(ActionTypes.GET_AGENT_CAPABILITY_TOKEN), payload: err });

          return Promise.reject(err);
        });
    }
  });
}

export function initializeWorker() {
  return createSDKAction(ActionTypes.INIT_WORKER, {
    callback: (sdk, dispatch) => {
      dispatch({ type: ActionTypes.INIT_WORKER });

      return Promise.resolve();
    }
  });
}

export function workerReady() {
  return createSDKAction(ActionTypes.WORKER_READY, {
    callback: (sdk, dispatch) => {
      dispatch({ type: ActionTypes.WORKER_READY });

      return Promise.resolve();
    }
  });
}

export function initializeDevice() {
  return createSDKAction(ActionTypes.INIT_DEVICE, {
    callback: (sdk, dispatch) => {
      dispatch({ type: ActionTypes.INIT_DEVICE });

      return Promise.resolve();
    }
  });
}

export function deviceReady() {
  return createSDKAction(ActionTypes.DEVICE_READY, {
    callback: (sdk, dispatch) => {
      dispatch({ type: ActionTypes.DEVICE_READY });

      return Promise.resolve();
    }
  });
}
